module.exports = __webpack_public_path__ + "static/img/logo-large.bba0072.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/logo-large.png
// module id = bG1/
// module chunks = 8